import { useCallback, useEffect, useMemo, useState } from "react"

import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

function hookTagsFactory() {
  return ({ fetch, lists, collections: { collectionsURL } }) => {
    const [items, setItems] = useState([])

    const list = useCallback(async () => {
      const data = await fetch({
        url: `${collectionsURL}/tags`,
      })
      setItems(data)
      return data
    }, [fetch, collectionsURL])

    return useMemo(() => {
      const store = {
        items,
        list,
        useLoad: () => {
          useEffect(() => {
            list()
          }, [])

          return useCallback(() => list(), [])
        },
      }

      return {
        lists: {
          ...lists || {},
          tags: store,
        },
      }
    }, [items, list, lists])
  }
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionsFactory('log-viewer')
  .extend(hookTagsFactory())
  .factory()

export {
  Provider as LogViewerProvider,
  useStore as useLogViewerStore,
}
